export default {
  allowConnectToDB: true,
  overrideProportionalResize: true,
};
